export default __webpack_public_path__ + "static/media/search.940819e4.svg";